import React from 'react'
import ReactDOM from 'react-dom'
import MyPages from './mypages'
import { store } from '../../store' 

$.fn.mypages = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(MyPages, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-mypages]').mypages();
});